import { defineComponent as _defineComponent } from 'vue';
import store from '@/store';
/**
 * Copies the link that opens the booking in the addons app, for staff to send the guest themselves.
 * Cancelled and checked-out bookings have no link.
 */
export default /*#__PURE__*/ _defineComponent({
    __name: 'BookingAddonsLinkButton',
    props: {
        addonsAppUrl: null
    },
    setup(__props) {
        const props = __props;
        // Clipboard bara tillgängligt vid https
        const isSecureContext = window.isSecureContext;
        const copyAddonsAppUrl = () => {
            if (!props.addonsAppUrl) {
                return;
            }
            window.navigator.clipboard.writeText(props.addonsAppUrl);
            store.dispatch('snackbars/createSnackbar', { color: 'success', text: 'Tillvalslänken kopierad' });
        };
        return { __sfc: true, props, isSecureContext, copyAddonsAppUrl };
    }
});
